export const navData = () => {
  return [
    {
      anchor: "#video",
      title: "Video",
    },
    {
      anchor: "#the-collection",
      title: "The Collection",
    },
    {
      anchor: "#the-story",
      title: "The Story",
    },
    {
      anchor: "#the-artist",
      title: "The Artist",
    },
    {
      anchor: "#the-good",
      title: "The Good",
    },
  ];
};

export const deGuzmanNavData = () => {
  return [
    {
      anchor: "#video",
      title: "Video",
    },
    {
      anchor: "#the-collection",
      title: "The Collection",
    },
    {
      anchor: "#the-story",
      title: "The Story",
    },
    {
      anchor: "#the-artist",
      title: "The Artist",
    },
  ];
};
